import { filter } from 'lodash';
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import {
  Box,
  Card,
  Table,
  Button,
  TableRow,
  // Checkbox,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Chip
} from '@mui/material';
// redux
// utils
import { addOneDay, fDate, fDateTime } from '../../../../../utils/formatTime';
import { fCurrency } from '../../../../../utils/formatNumber';

import useSettings from '../../../../../hooks/useSettings';
// components
import Page from '../../../../Page';
// import Label from '../../Label';
import Scrollbar from '../../../../Scrollbar';
import SearchNotFound from '../../../../SearchNotFound';
import { ProductListHead, Label } from '../../../e-commerce/product-list';
import EnvioListToolbar from '../../../paquetes/EnvioListToolbar';
import { firestore } from '../../../../../contexts/FirebaseContext';
import CartCheckoutComplete from '../../../cotenvio/checkout/CartCheckoutComplete';
import { clipPaymentConfirm, getConvertCompras, hacerEnvioRedpack } from '../../../../../_apis_/dagpacket';
import useAuth from '../../../../../hooks/useAuth';
import PaqueteriaAvatar from '../../../paquetes/general/PaqueteriaAvatar';
import { Icon } from '@iconify/react';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import UserBasicInfo from '../../../usuarios/general/UserBasicInfo';
import { useFilterByDate } from '../../../../../hooks/useFilterByDate';
import useHandleFiltroFecha from '../../../../../hooks/useHandleFiltroFecha';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: '#', alignRight: false },
  { id: 'cajero', label: 'Cajero', alignRight: false },
  { id: 'rate_provider', label: 'Paqueteria', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },

  { id: 'costo', label: 'Costo', alignRight: true },
  { id: 'utilidad', label: 'Utilidad', alignRight: true },
  { id: 'shippingValue', label: 'Precio', alignRight: true },
  { id: 'tu_utilidad', label: 'Tu utildad', alignRight: true },
  { id: 'city_from', label: 'Origen', alignRight: true },
  { id: 'city_to', label: 'Destino', alignRight: true },
  { id: 'state', label: 'Estado de pago', alignRight: true },
  { id: 'status', label: 'Estado de envio', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_product) => _product?.id?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }

  return stabilizedThis.map((el) => el[0]);
}

// ----------------------------------------------------------------------

export default function ListaEnvioLicenciatario({ listaEnvios = [] }) {
  const [envios, setEnvios] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [orderBy, setOrderBy] = useState('createdAt');
  const [statusEnvioSelected, setStatusEnvioSelected] = useState([]);

  const [fecha, setFecha] = useState('');
  useEffect(() => {
    setEnvios(listaEnvios);
  }, [listaEnvios]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = envios.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - envios.length) : 0;

  const filterDate = (data, date) => {
    if (date.length > 0) {
      return data.filter((item) => item.created_at.toDate().toISOString().substring(0, 10) === date);
      // return data;
    }
    return data;
  };

  const filterStatus = (data, status) => {
    if (status === 'QUOTE') {
      return data.filter((item) => item.status === status || item.status === 'PURCHASE');
    }
    if (status === 'LABEL_CREATED') {
      return data.filter((item) => item.status === status || item.status === 'CREATED');
    }
    if (status === 'PENDIENTE-CANCELACION') {
      return data.filter((item) => item.state === 'PENDIENTE-CANCELACION');
    }
    if (status === 'CANCELADO') {
      return data.filter((item) => item.status === 'CANCELADO');
    }

    return data;
  };

  const handleStatus = (selectedStatuses) => {
    setStatusEnvioSelected(selectedStatuses);
  };

  const { handleDesde, handleHasta, handleResetFechas, hasta, desde } = useHandleFiltroFecha();
  const newHasta = addOneDay(hasta);

  const filteredByStatus = filterStatus(envios, statusEnvioSelected);

  const filteredByDate = filterDate(filteredByStatus, fecha);

  const filteredProducts = applySortFilter(filteredByDate, getComparator(order, orderBy), filterName);
  const { filteredData } = useFilterByDate(filteredProducts, desde, newHasta, 'updated_at');

  const isProductNotFound = filteredProducts.length === 0;

  return (
    <Page title="Licenciatarios - Lista de envios totales">
      <Card>
        <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
          <Typography component="h2" variant="h4">
            Envios
          </Typography>
        </Box>
        <Divider />
        <EnvioListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          date={fecha}
          setDate={setFecha}
          handleStatus={handleStatus}
          onDesdeDate={handleDesde}
          onHastaDate={handleHasta}
          hasFilterDate
          hasReporte
          desde={desde}
          hasta={hasta}
          handleResetFechas={handleResetFechas}
          statusEnvioSelected={statusEnvioSelected}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ProductListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={envios.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkbox={false}
              />
              <TableBody>
                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    id,
                    created_at,
                    shippingValue,
                    city_from,
                    city_to,
                    state,
                    rate_provider,
                    provider,
                    trackingNumber,
                    status,
                    payment_id,
                    user_id,
                    costo,
                    utilidad
                  } = row;

                  const createDate = created_at.value
                    ? fDate(new Date(created_at.value))
                    : fDateTime(created_at.toDate());

                  const isItemSelected = selected.indexOf(id) !== -1;

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell component="th" scope="row" padding="none">
                        <Typography fontSize="12px" variant="subtitle2" noWrap>
                          {id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <UserBasicInfo user_id={user_id} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <PaqueteriaAvatar size="small" rate_provider={rate_provider} />
                          <Typography variant="subtitle2" fontSize="12px">
                            {rate_provider}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ maxWidth: '100px' }}>{createDate}</TableCell>
                      <TableCell align="right">{fCurrency(costo)}</TableCell>
                      <TableCell align="right">{fCurrency(utilidad)}</TableCell>
                      <TableCell align="right">{fCurrency(shippingValue)}</TableCell>
                      <TableCell align="right">{fCurrency(utilidad * 0.7)}</TableCell>
                      <TableCell align="right">{city_from}</TableCell>
                      <TableCell align="right">{city_to}</TableCell>
                      <StatusTableCell data={row} />
                      {/* <TableCell align="right">
                          {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />}
                        </TableCell> */}

                      <TableCell align="right">{status && <Label text={status} />}</TableCell>

                      <TableCell align="right">
                        <Button
                          variant="contained"
                          // sx={{ padding: '0px' }}
                          size="small"
                          endIcon={<Icon icon="eva:file-text-fill" />}
                        >
                          <RouterLink
                            to={`/dashboard/paquetes/envios/${id}?payment_id=${payment_id}&paqueteria=${rate_provider}&provider=${provider}&codigo=${trackingNumber}`}
                            style={{ color: '#fff', textDecoration: 'none' }}
                          >
                            Detalle
                          </RouterLink>
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isProductNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      <Box sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={envios.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* </Container> */}
    </Page>
  );
}

function StatusTableCell({ data }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { state, payment_source, payment_id } = data;

  const getStatusClip = useCallback(() => {
    setLoading(true);
    clipPaymentConfirm(payment_id)
      .then((res) => {
        console.log('clip message', res);
        setLoading(false);
        setMessage('pagado clip');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [payment_id]);

  useEffect(() => {
    if (payment_source === 'CLIP') {
      getStatusClip();
    }
    setMessage(state || '-');
  }, [payment_source, getStatusClip, state]);
  // console.log(data);
  return (
    <TableCell align="right">
      {/* {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />} */}
      {loading ? 'loading...' : <Chip sx={{ fontSize: '10px' }} label={message} size="small" color="info" />}
    </TableCell>
  );
}
